export default "<p>image-upload works!</p>\n"